// "다시 보지 않기" dismiss 상태를 localStorage 에 저장/조회하는 SSR-safe 헬퍼.
// 무채점 정답 공개(JCG-2510)·다시 풀기(JCG-2527) 등 "다시 보지 않기" 확인 다이얼로그가 공유한다.
// SSR(window 없음)·프라이빗 모드 등으로 localStorage 접근이 막혀도 throw 하지 않는다.
import { readBrowserPreference, writeBrowserPreference } from "./browser-preference";

export function isConfirmDismissed(key: string): boolean {
  return readBrowserPreference(key) === "true";
}

export function setConfirmDismissed(key: string): void {
  if (typeof window !== "undefined") writeBrowserPreference(key, "true");
}
